import { Component } from 'react';
import {connect} from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

export class SessionAwareComponent extends Component {
    static propTypes = {
        session: ImmutablePropTypes.map.isRequired,
    }

    /* eslint-disable no-unused-vars */
    componentDidUpdate(prevProps, prevState) {
        if (this.props.session !== prevProps.session) {
            this.onSessionChange(prevProps.session, this.props.session);
        }
    }

    /* eslint-disable no-unused-vars */
    onSessionChange(prevSession, session) {}
}

export default connect(state => ({
    session: state.session,
}))(SessionAwareComponent);
